<template>
  <div class="compare-wrap">
    <div class="compare">
      <div class="before-amount">
        <div class="title">컨설팅 전</div>
        <div class="amount-wrap">
          <span class="currency">₩ </span>
          <span class="amount">{{ $Util.formatNumber(beforeTotalBill) }}</span>
        </div>
      </div>
      <div class="arrow"></div>
      <div class="after-amount">
        <div class="title">컨설팅 후</div>
        <div class="amount-wrap">
          <span class="currency">₩ </span>
          <number-animation ref="number1"
                            :before="beforeTotalBill"
                            :after="afterTotalBill">
          </number-animation>
        </div>
      </div>
    </div>
    <div class="compare-result">
      <!--      컨설팅 전 대비 <span class="accent">{{ $Util.formatNumber(savingAmount) }}</span> 원 절감 (절감율 : <span class="accent">{{ savingAmountRate }}</span>%)-->
      컨설팅 전 대비
      <span class="accent">
        ₩<number-animation ref="number2"
                          :before="0"
                          :after="savingAmount">
        </number-animation>
      </span> 절감 (절감율 : <span class="accent">{{ savingAmountRate }}</span>%)
    </div>
  </div>
</template>
<script>
import NumberAnimation from '@/components/pages/NumberAnimation'

export default {
  components: {
    NumberAnimation
  },
  props: {
    beforeTotalBill: 0,
    afterTotalBill: 0,
    savingAmount: 0,
    savingAmountRate: 0.0
  },
  data: function () {
    return {
      beforeSavingAmount: 0
    }
  },
  created: function () {

  },
  methods: {
    start: function () {
      this.$refs.number1.start()
      this.$refs.number2.restart()
    }
  }
}
</script>
<style lang="scss" scoped>
.compare-result {
  width: 50%;
  border: 1px solid #E6E6E6;
  background-color: #FAFAFA;
  margin: 2rem auto;
  padding: 1rem;
  text-align: center;

  .accent {
    color: #00bd91;
    font-weight: 700;
    font-size: 1.4rem;
  }
}

.compare {
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
  align-items: center;

  .title {
    color: #BDBDBD;
    font-size: 1.2rem;
  }

  .currency {
    color: #BDBDBD;
    font-size: 1.2rem;
  }

  .amount {
    height: 3.4rem;
    line-height: 3.4rem;
  }

  .before-amount {
    width: 35%;
    vertical-align: top;
    font-size: 2rem;
    text-align: right;

    .amount {
      text-decoration: line-through;
      text-align: right;
    }
  }

  .arrow {
    background-image: url(../../assets/img/i_arrow.svg);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    width: 5%;
    height: 90px;
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .after-amount {
    width: 35%;
    vertical-align: top;
    font-size: 3.4rem;

    .title {
      margin-left: 22px;
    }
  }

}
</style>
